import React from "react";
import { listActu } from "../actions/actus";
import { tempAlWait } from "../helpers";
import LittleActu from "./LittleActu";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

class ShortActus extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        actus: [],
        pageActu: 0,
    }

    componentDidMount() {
        this.props.listActu({nb: 3});
        this.setState({
            alert: tempAlWait()
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.alert != this.state.alert) {
            this.props.changeAlert(this.state.alert);
        }

        if (prevProps.redListActu != this.props.redListActu) {
            this.setState({
                alert: this.props.redListActu.alert,
                actus: this.props.redListActu.datas
            })
        }
    }

    render() {
        return <div className="particle__blogs">
            {/** Header **/}
            <header className="particle__blogs__hdr">
                <h3 className="particle__blogs__ttl">Posts récents</h3>
                <Link
                    title="Voir toutes les publications"
                    aria-label="Voir toutes les publications"
                    className="particle__blogs__link"
                    to="/actualites"
                >Voir tout</Link>
            </header>

            {/** Liste **/}
            <div className="particle__blogs__list">
                {
                    this.state.actus.map((act, key) => {
                        return <LittleActu
                            key={`liblog-${key}`}
                            data={act}
                            changeAlert={(al) => this.setState({alert: al})}
                            indexer={key}
                            pageActu={this.state.pageActu}
                        />
                    })
                }

                {/** Boutons directionnels **/}
                <button
                    title="Voir l'article précédent"
                    aria-label="Voir l'article précédent"
                    className="particle__blogs__btndir"
                    disabled={this.state.pageActu == 0}
                    onClick={() => this.setState({pageActu: this.state.pageActu - 1})}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button
                    title="Voir l'article suivant"
                    aria-label="Voir l'article suivant"
                    className="particle__blogs__btndir particle__blogs__btndir--right"
                    disabled={this.state.pageActu == (this.state.actus.length - 1)}
                    onClick={() => this.setState({pageActu: this.state.pageActu + 1})}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>

                {/** Pagination **/}
                <div className="particle__blogs__pagination">
                    <button
                        title="Voir le premier article"
                        aria-label="Voir le premier article"
                        className={`particle__blogs__btnpage ${this.state.pageActu == 0 && "particle__blogs__btnpage--active"}`}
                        onClick={() => this.setState({pageActu: 0})}
                    ></button>
                    <button
                        title="Voir le second article"
                        aria-label="Voir le second article"
                        className={`particle__blogs__btnpage ${this.state.pageActu == 1 && "particle__blogs__btnpage--active"}`}
                        onClick={() => this.setState({pageActu: 1})}
                    ></button>
                    <button
                        title="Voir le troisième article"
                        aria-label="Voir le troisième article"
                        className={`particle__blogs__btnpage ${this.state.pageActu == 2 && "particle__blogs__btnpage--active"}`}
                        onClick={() => this.setState({pageActu: 2})}
                    ></button>
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        redListActu: state.redListActu
    }
}

const mapDispatchToProps = {
    listActu
}

export default connect(mapStateToProps, mapDispatchToProps)(ShortActus);